<template>
    <div>
        <client-only>
            <slick
                ref="slickImg"
                id="social-slider"
                :options="slickOptions"
                class="slick-for"
            >
                <div v-for="(slide, i) in slider" :key="i" class="pt-4">
                    <p class="gotham-bold text-white h5" v-html="slide.header"></p>
                    <p class="gotham-book mb-0 h4 text-white">
                        {{ slide.desc }}
                    </p>
                    <p class="gotham-bold text-white h5 mt-1">
                        "{{ slide.usage }}"
                    </p>
                </div>
            </slick>
        </client-only>
    </div>
</template>

<script>
export default {
    data() {
        return {
            slider: [
                {
                    header: "Encyclopaedia Directoria Principia",
                    desc: "Or, A Short",
                    usage: 'Dictionary Of Arts & Languages As Commonly Used Within The Territory Of 1063 Eglinton Ave. W., Toronto, ON.'
                },
                {
                    header: "hallo! <span class='h6'>[hal-lo]</span><br>verb (used with object), sen·tenced, sen·tenc·ing.",
                    desc: "Different than the commonplace 'Hello', this phrased is most often used in circumstances of anticipation, fulfillment, or realization.",
                    usage: "Awards season is coming up — Hallo!"
                },
                {
                    header: "Baby",
                    desc: "Term used to refer to any employee or individual born after November 15 1996; the same date Space Jam was released.",
                    usage: "You don't remember the day the Raptors joined the NBA? My gosh, you're a baby!"
                },
                {
                    header: "Brochacho",
                    desc: '"The amalgamation of "brother" and "muchacho", often used as a term of endearment; popularized in Indiana circa 1980\'s."',
                    usage: "Hey brochacho, how was your long weekend?"
                },
                {
                    header: "Chachka",
                    desc: '"An icon, logotype, or any such visual identifier used in complementary addition to a given work."',
                    usage: "That branding package looks good, but add a little chachka to the cover page"
                },
                {
                    header: "Far-Out",
                    desc: 'A response used primarily by writers and designers to convey a sense of awe or pleasurable disbelief; most commonly accompanied by the noun "man".',
                    usage: "Upon hearing the Creative Director's admiration for his copy, the writer reservedly responded 'Far out, man'"
                },
                {
                    header: "Patrick",
                    desc: "Placeholder name; attribute to anyone who's name the speaker, for whatever reason, cannot remember.",
                    usage: "Liz, I've been sitting across from you for over a year now, and you still call me Patrick"
                },
                {
                    header: "Sheeeeeeeesh",
                    desc: "An expression used in excitement, disappointment, bewilderment, or any similar emotion to convey it.",
                    usage: "We beat 5 other agencies to win that client? Sheeeeeeeesh!"
                }
                
            ],
            slickOptions: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
                infinite: true,
                lazyLoad: "ondemand",
                vertical: false,
                verticalSwiping: false,
                asNavFor: null,
                autoplay: true,
                fade: true,
                // appendArrows: null,
                // appendDots: null,
                autoplaySpeed: 4000,
                adaptiveHeight: false,
            },
        }
    }
}
</script>